import ModalManager from 'utils/modal_manager';
import AjaxComponentLoader from 'utils/ajax_component_loader';

export default class LoginRegister {
  static newLoginModal(return_url) {
    AjaxComponentLoader.load({
      component: 'modals/login_register_modal',
      type: 'component',
      data: {
        return_url: return_url
      }
    }).then((html) => {
      $('body').append(html);
      ModalManager.open('#js-login-register-modal');
    }).catch( () => {
      Turbolinks.visit(`/conta/entrar?return_url=${return_url}`);
    });
  }
}
